<template>
  <div class="file-box">
    <span v-if="imgList.length<=0&&fileList.length<=0">{{message}}</span>
    <file-swiper-item v-if="swiper" :imgList="imgList" :fileList="fileList" :deletebnt="deletebnt"></file-swiper-item>
    <fileitem v-else :imgList="imgList" :fileList="fileList" :deletebnt="deletebnt"></fileitem>
  </div>
</template>
<script>
import fileitem from "./fileItem";
import fileSwiperItem from "./filesItemSwiper";
import * as dd from "dingtalk-jsapi";
const { fileBaseUrl } = require(`@/config/develop.json`);
export default {
  components: {
    fileitem,
    fileSwiperItem
  },
  props: {
    swiper: false,
    deletebnt: false,
    message: "",
    fileInfo: {
      type: Object,
      default() {
        return { filesrcs: "", filenames: "" };
      }
    }
  },
  data() {
    return {
      fileList: [],
      imgList: [],
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: "1.6%",
        onTransitionEnd: function(swiper) {
          if (swiper.progress == 1) {
            swiper.activeIndex = swiper.slides.length - 1;
          }
        }
      }
    };
  },
  methods: {
    deleteimg(index) {
      let res = this.imgList.splice(index, 1)[0];
      this.deleteSource(res);
    },
    deletefile(index) {
      let res = this.fileList.splice(index, 1)[0];
      this.deleteSource(res.fileSrc);
    },
    deleteSource(deleteObject) {
      let arr = this.fileInfo.filesrcs.split("|");
      for (var j = 0, len = arr.length; j < len; j++) {
        if (arr[j]) {
          let yuan = arr[j].split("/");
          if (deleteObject.indexOf(yuan[yuan.length - 1]) > -1) {
            arr.splice(j, 1);
          }
        }
      }
      this.fileInfo.filesrcs = arr.join("|");
    },
    previewImage(src) {
      dd.biz.util.previewImage({
        urls: this.imgList, //图片地址列表
        current: src, //当前显示的图片链接
        onSuccess: function(result) {
          /**/
        },
        onFail: function(err) {}
      });
    },
    previewFile(fileSrc) {
      fileSrc = "http://ow365.cn/?i=21072&ssl=1&furl=" + encodeURIComponent(fileSrc);    
      debugger; 
      dd.biz.util.openLink({
        url: fileSrc, //要打开链接的地址
        onSuccess: function(result) {
          /**/
        },
        onFail: function(err) {}
      });
    },
    fileFormatToList(filesrcs, filenames) {
      if (filesrcs != null && filesrcs.length > 0) {
        let fileUrl = fileBaseUrl;
        var fileSrcArray = filesrcs.split("|");
        var fileNameArray = filenames.split("|");
        this.fileList = [];
        this.imgList = [];
        for (var fileindex in fileSrcArray) {
          let filesrc = fileSrcArray[fileindex].toLowerCase();
          var imgformat = /^(\s|\S)+(jpg|png|jpeg|gif|JPG|PNG|JPEG|GIF)+$/;
          if (imgformat.test(filesrc))
            this.imgList.push(fileUrl + filesrc.replace("~", ""));
          else {
            let wordformat = /^(\s|\S)+(.doc|.docx|.DOC|.DOCX)+$/;
            let excelformat = /^(\s|\S)+(.xls|.xlsx|.XLS|.XLSX)+$/;
            let pptformat = /^(\s|\S)+(.ppt|.pptx|.PPT|.PPTX)+$/;
            let zipformat = /^(\s|\S)+(.zip|.rar|.ZIP|.RAR)+$/;
            let audioformat = /^(\s|\S)+(.mp3|.wav)+$/;
            let videoformat = /^(\s|\S)+(.mp4|.rmvb|.avi|.ts)+$/;
            let pdfformat = /^(\s|\S)+(.pdf)+$/;
            let textformat = /^(\s|\S)+(.txt)+$/;
            if (wordformat.test(filesrc))
              this.fileList.push({
                fileSrc: fileUrl + filesrc.replace("~", ""),
                filefromat: "word",
                fileName: fileNameArray[fileindex],
                fileSize: 10
              });
            else if (excelformat.test(filesrc))
              this.fileList.push({
                fileSrc: fileUrl + filesrc.replace("~", ""),
                filefromat: "excel",
                fileName: fileNameArray[fileindex],
                fileSize: 10
              });
            else if (pptformat.test(filesrc))
              this.fileList.push({
                fileSrc: fileUrl + filesrc.replace("~", ""),
                filefromat: "ppt",
                fileName: fileNameArray[fileindex],
                fileSize: 10
              });
            else if (zipformat.test(filesrc))
              this.fileList.push({
                fileSrc: fileUrl + filesrc.replace("~", ""),
                filefromat: "zip",
                fileName: fileNameArray[fileindex],
                fileSize: 10
              });
            else if (audioformat.test(filesrc))
              this.fileList.push({
                fileSrc: fileUrl + filesrc.replace("~", ""),
                filefromat: "audio",
                fileName: fileNameArray[fileindex],
                fileSize: 10
              });
            else if (videoformat.test(filesrc))
              this.fileList.push({
                fileSrc: fileUrl + filesrc.replace("~", ""),
                filefromat: "video",
                fileName: fileNameArray[fileindex],
                fileSize: 10
              });
            else if (pdfformat.test(filesrc))
              this.fileList.push({
                fileSrc: fileUrl + filesrc.replace("~", ""),
                filefromat: "pdf",
                fileName: fileNameArray[fileindex],
                fileSize: 10
              });
            else if (textformat.test(filesrc))
              this.fileList.push({
                fileSrc: fileUrl + filesrc.replace("~", ""),
                filefromat: "text",
                fileName: fileNameArray[fileindex],
                fileSize: 10
              });
          }
        }
      }
    }
  },
  watch: {
    fileInfo: {
      handler(newValue, oldValue) {
        this.fileFormatToList(newValue.filesrcs, newValue.filenames);
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
.file-box {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Share/Preview/fileBox.vue